import { Link } from 'react-router-dom'
import { LanguageSwitcher } from './LanguageSwitcher'

export function PublicNavigationBar() {
  return (
    <nav className="sticky top-0 z-50 w-full border-b bg-card/95 backdrop-blur">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-14 items-center">
          <Link to="/">
            <img src="/images/logo.png" alt="The Ranch" className="h-10 w-auto" />
          </Link>
          <LanguageSwitcher />
        </div>
      </div>
    </nav>
  )
}
